import { Link } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import { useMenu } from "../hooks/useMenu";
import { useScroll } from "../hooks/useScroll";

export const Navigation = () => {
  const { isScrolled } = useScroll();
  const { isMenuClosed, toggleMenu } = useMenu();

  return (
    <Header $isActive={!isMenuClosed} $isScrolled={isScrolled}>
      <Logo src="./logo4.png" alt="Logo" $isScrolled={isScrolled} />
      <MenuBar>
        <BurgerMenu
          className="burger-menu"
          $isActive={!isMenuClosed}
          onClick={() => toggleMenu()}
        >
          ☰
        </BurgerMenu>
      </MenuBar>
      <NavMenu $isActive={!isMenuClosed} $isScrolled={isScrolled}>
        <CloseMenuButton className="close-menu" onClick={() => toggleMenu()}>
          ✖
        </CloseMenuButton>
        <NavList>
          <NavListItem>
            <NavLink to="/">Home</NavLink>
          </NavListItem>
          <NavListItem>
            <NavLink to="/photo">Fotogalerie</NavLink>
          </NavListItem>
          <NavListItem>
            <NavLink to="/contact">Kontakt</NavLink>
          </NavListItem>
          <NavListItem>
            <NavLink to="/subsidy">Dotace</NavLink>
          </NavListItem>
        </NavList>
      </NavMenu>
    </Header>
  );
};

const menumobgrow = keyframes`
  from {
    clip-path: polygon(0 0, 100% 0, 100% 150px, 0 150px);
  }

  to {
    clip-path: polygon(0 0, 100% 0, 100% 300px, 0 300px);
  }
`;

const BurgerMenu = styled.button<{ $isActive: boolean }>`
  display: none;

  @media (max-width: 768px) {
    display: ${(props) => (props.$isActive ? "none" : "block")};
    position: fixed;
    top: 10px;
    right: 10px;
    font-size: 32px;
    background: none;
    border: none;
    cursor: pointer;
    color: rgb(52 181 75);
  }
`;

const MenuBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #ffffffbb;
  left: 0;
  margin: 0 35px 0 0;
  z-index: 100;
  /* box-shadow: 0px 0px 140px 90px rgba(255, 255, 255, 0.9); */
`;

const Logo = styled.img<{ $isScrolled: boolean }>`
  height: ${(props) => (props.$isScrolled ? "95px" : "220px")};
  position: fixed;
  top: ${(props) => (props.$isScrolled ? "10px" : "50px")};
  box-shadow: inset 0px 0px 82px 100px rgba(255, 255, 255, 0.9),
    0px 0px 82px 100px rgba(255, 255, 255, 0.9);
  display: block;
  transition: height 0.7s ease, top 0.7s ease;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Header = styled.header<{ $isActive: boolean; $isScrolled?: boolean }>`
  position: fixed;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 1000;
  top: 0;
  background-image: url("./main_bg_small2.png");
  background-size: 1920px auto;
  /* Zajišťuje, že obrázek pokryje celý element */

  background-position: center top;
  /* Vycentruje obrázek */
  background-repeat: no-repeat;
  /* Zabrání opakování obrázku */
  clip-path: ${({ $isScrolled }) =>
    $isScrolled
      ? " polygon(0 0, 100% 0, 100% 60%, 0 60%)"
      : " polygon(0 0, 100% 0, 100% 72%, 0 90%)"};
  padding: ${({ $isScrolled }) =>
    $isScrolled ? "0 0 160px 0" : "42vh 0 200px 0"};
  transition: padding 0.7s ease, clip-path 0.7s ease;
  @media (max-width: 768px) {
    height: 20%;
    justify-content: right;
    padding: 0 0 100px 0;
    background-image: ${(props) =>
      props.$isActive
        ? "url('./mobile_long_bg.png')"
        : "url('./mobile_bg2.png')"};
    background-position: top;
    background-size: contain;
    /* Vycentruje obrázek */
    background-repeat: no-repeat;
    clip-path: ${(props) =>
      props.$isActive
        ? "polygon(0 0, 100% 0, 100% 300px, 0 300px)"
        : " polygon(0 0, 100% 0, 100% 150px, 0 150px)"};
    transform-origin: top;

    ${({ $isActive }) =>
      $isActive &&
      css`
        animation: ${menumobgrow} 0.3s ease-in-out;
      `}
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: opacity(0.2);
    z-index: -1;
  }
`;

const CloseMenuButton = styled.button`
  display: none;

  @media (max-width: 768px) {
    border-radius: 35px;
    width: 0px;
    height: 0px;
    display: block;
    font-size: 32px;

    border: none;
    cursor: pointer;
    color: rgb(52 181 75);
    position: absolute;
    top: 10px;
    right: 38px;
    box-shadow: 0px 0px 140px 90px #ffffffb8;
  }
`;

const NavMenu = styled.nav<{ $isActive: boolean; $isScrolled?: boolean }>`
  margin: auto;
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding: 20px;
  margin: 100px 0 0 0;
  margin: ${({ $isScrolled }) => ($isScrolled ? "120px 0 0 0" : "5px 0 0 0")};
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
  @media (max-width: 768px) {
    display: ${(props) => (props.$isActive ? "flex" : "none")};
    flex-direction: column;
    justify-content: start;
    align-items: center;
    position: fixed;
    background-color: rgba(125, 175, 40, -0.1);
    margin: 0 0 30px 0;
    padding: 18vw 20px 0 20px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${(props) =>
      props.$isActive
        ? "url('./mobile_long_bg.png')"
        : "url('./mobile_bg2.png')"};
    background-size: contain;
    /* Zajišťuje, že obrázek pokryje celý element */
    background-position: top;
    /* Vycentruje obrázek */
    background-repeat: no-repeat;
    z-index: 1000;
    transform-origin: top;
  }
`;

const NavList = styled.ul`
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin: 0 0 0 0;
  list-style: none;
  z-index: 50;
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: auto auto;
    background-color: #ffffffed;
    padding: 20px;
    border-radius: 8px;
    flex-direction: column;
    align-items: center;
  }
`;

const NavListItem = styled.li`
  @media (max-width: 768px) {
    padding: 0.3rem 1rem;
    text-align: center;
  }
`;

const NavLink = styled(Link)`
  color: rgb(52 181 75);
  font-weight: bold;
  margin: 0 15px;
  text-decoration: none;
  padding: 0.5rem 1rem;
  &:hover {
    color: #5e8f20;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center; /* Horizontální centrování */
    text-align: center; /* Textové centrování */
    padding: 0 1rem;
  }
`;
